firebird.controller('waitingRoomHostMessageCtrl', [
    'growlService',
    '$scope',
    'storageService',
    'socketService',
    'localizationService',
    'subscriptionService',
    'userPairStateService',
    function (
        growlService,
        $scope,
        storageService,
        socketService,
        localizationService,
        subscriptionService,
        userPairStateService
    ) {
        var storageKey = 'waitingRoomHostMessage';
        var self = this;
        self.message = '';
        self.isNodeDisconnected = false;
        self.modalState = 'closed';
        self.sendingEmptyData = false;
        self.modalsAvailable = false;
        self.rootSubscription = undefined;

        $scope.$on('node-disconnected', onNodeDisconnected);
        $scope.$on('node-reconnected', onNodeReconnected);

        self.cancel = function () {
            self.modalState = 'closed';
        };

        self.onInputChange = function () {
            self.sendingEmptyData = false;
        };

        self.send = function () {
            var messageToWaitingRoom = (self.message || '').trimRight().substring(0, 140);
            if (messageToWaitingRoom.length > 0) {
                self.cancel();
                storageService.set(storageKey, messageToWaitingRoom);

                if (self.isNodeDisconnected) {
                    growlService.show(
                        localizationService.translate('JOIN_REQUEST_LIST.SENDING_YOUR_MESSAGE_NOTIFICATION'),
                        'success'
                    );
                    return;
                }

                sendMessage(messageToWaitingRoom);
            } else {
                self.sendingEmptyData = true;
            }
        };

        // initialize the component.
        self.init = function () {
            self.rootSubscription = subscriptionService.createSubscription();
            self.rootSubscription.add(
                userPairStateService.modalsAvailable$.subscribe(next => {
                    self.modalsAvailable = next;
                })
            );
            // check and resend message if node was connected before we initialized current component.
            resendMessage();
        };

        $scope.$on('show-modal', function (e, modalName) {
            if (modalName === 'waitingRoomHostMessage') {
                resetState();
                self.modalState = 'open';
            }
        });

        function resetState() {
            self.sendingEmptyData = false;
            self.message = '';
        }

        function onNodeDisconnected() {
            self.isNodeDisconnected = true;
        }

        function onNodeReconnected() {
            self.isNodeDisconnected = false;
            // in case node server crashed would be better to wait a bit
            if (!self.modalsAvailable) {
                setTimeout(resendMessage, 1000);
            }
        }

        function resendMessage() {
            var message = storageService.get(storageKey);
            if (message) {
                sendMessage(message);
            }
        }

        function sendMessage(messageToWaitingRoom) {
            socketService.send({
                message: 'message-to-waiting-room',
                data: { message: messageToWaitingRoom },
                callback: function (data) {
                    storageService.remove(storageKey);
                    if (data && data.result) {
                        successNotification();
                    } else {
                        dangerNotification();
                    }
                }
            });
        }

        function successNotification() {
            growlService.show(localizationService.translate('NOTIFICATIONS.MESSAGE_SENT'), 'success');
        }

        function dangerNotification() {
            growlService.show(localizationService.translate('NOTIFICATIONS.MESSAGE_NOT_SENT'), 'danger');
        }

        self.init();
    }
]);
